export default "__VITE_PUBLIC_ASSET__ec83e628__"